"use strict";

require("./_producer");